import React from 'react';
import { Box, useTheme, useMediaQuery, Grid, Typography } from '@material-ui/core';
import logo from '../../images/logo_header.png';
import Header_logo_colored from '../../images/Header_logo_colored.png';

const HeaderLogo = () => {
    const theme = useTheme();
    const isXsDown = useMediaQuery(theme.breakpoints.down('xs'));

    return (
        <Box
            display="flex"
            alignItems="center"
            style={{
                padding: '5px 14px 5px 14px'
            }}>
            <img
                src={isXsDown ? Header_logo_colored : logo}
                alt="ZeDeId Tools logo"
                style={{ height: 42, width: 'auto', objectFit: 'contain', marginRight: 10 }}
            />
            <Grid container direction="column" spacing={0} style={{ lineHeight: 1 }}>
                <Grid item>
                    <Typography
                        variant="h6"
                        style={{
                            fontWeight: 600,
                            fontSize: '1.3rem',
                            color: isXsDown ? '#24C3B5' : '#fff'
                        }}>
                        ZeDeId Tools
                    </Typography>
                </Grid>
            </Grid>
        </Box>
    );
};

export default HeaderLogo;
